import { FormControl, FormLabel, Grid } from '@mui/material';
import CategoryCard from 'app/containers/Articles/Article/components/CategoryCard';
import { useFormikContext } from 'formik';
import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';
import Flat from 'assets/flat.svg';
import Materials from 'assets/materials.svg';
import Belongings from 'assets/belongings.svg';

export default function Category() {
  const { values, setFieldValue, errors }: any = useFormikContext();
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid container>
        <FormControl className="listingModal__body__input" required error={errors.type}>
          <FormLabel className="listingModal__body__input__label">
            {t(translations.pages.listings.create.category.selectCategory())}
          </FormLabel>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            className="listingModal__body__categories"
          >
            <Grid item xs={12} md={4} onClick={() => setFieldValue('type', 'study')}>
              <CategoryCard
                icon={<img src={Materials} alt="" />}
                headline={t(translations.pages.listings.type.study())}
                description={t(translations.pages.listings.create.category.studyDescription())}
                active={values.type === 'study'}
              />
            </Grid>
            <Grid item xs={12} md={4} onClick={() => setFieldValue('type', 'flat')}>
              <CategoryCard
                icon={<img src={Flat} alt="" />}
                headline={t(translations.pages.listings.type.flat())}
                description={t(translations.pages.listings.create.category.flatDescription())}
                active={values.type === 'flat'}
              />
            </Grid>
            <Grid item xs={12} md={4} onClick={() => setFieldValue('type', 'belongings')}>
              <CategoryCard
                icon={<img src={Belongings} alt="" />}
                headline={t(translations.pages.listings.type.belongings())}
                description={t(translations.pages.listings.create.category.belongingsDescription())}
                active={values.type === 'belongings'}
              />
            </Grid>
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
}
